import { Component } from 'react';
import styles from './css/Statistics.module.css';

export class Statistics extends Component {
  countPositiveFeedbackPercentage = () => Math.floor((this.props.good / (this.props.good + this.props.neutral + this.props.bad)) * 100);
  render() {
    return (
      <ul className={styles.stat_ul}>
        <li>Good: {this.props.good}</li>
        <li>Neutral: {this.props.neutral}</li>
        <li>Bad: {this.props.bad}</li>
        <li>Total: {this.props.good + this.props.neutral + this.props.bad}</li>
        <li>Percentage: {this.countPositiveFeedbackPercentage()}</li>
      </ul>
    );
  }
}